"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var use_locale_hook_1 = __importDefault(require("../../../context/locale/use-locale.hook"));
var IndicatorContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  color: ", ";\n  font-size: 12px;\n\n  svg {\n    position: relative;\n    top: 8px;\n    margin-right: 8px;\n    stroke: ", ";\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  color: ", ";\n  font-size: 12px;\n\n  svg {\n    position: relative;\n    top: 8px;\n    margin-right: 8px;\n    stroke: ", ";\n  }\n"])), function (_a) {
    var colours = _a.theme.colours;
    return colours.installationSketch.color;
}, function (_a) {
    var colours = _a.theme.colours;
    return colours.installationSketch.waterSurface;
});
var InstallationWaterLevelIndicator = function (_a) {
    var waterLevel = _a.waterLevel, unit = _a.unit, hideValue = _a.hideValue;
    var formatWithDigits = use_locale_hook_1.default().formatWithDigits;
    var formattedWaterLevel = formatWithDigits(waterLevel, 2);
    if (waterLevel === 0)
        return null;
    return (react_1.default.createElement(IndicatorContainer, { "data-test-id": 'water-level-indicator-container' },
        react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "23.939", height: "19.948", viewBox: "0 0 23.939 19.948" },
            react_1.default.createElement("path", { d: "M8236.333,4202.667h-16.666V4219", transform: "translate(-8212.394 -4201.667)", fill: "none", strokeWidth: "2" }),
            react_1.default.createElement("path", { d: "M8213,4215l7,5.333,6.333-5.333", transform: "translate(-8212.394 -4201.667)", fill: "none", strokeWidth: "2" })),
        hideValue !== true && (react_1.default.createElement("span", { "data-test-id": 'water-level-indicator' },
            formattedWaterLevel,
            unit))));
};
InstallationWaterLevelIndicator.displayName = 'InstallationWaterLevelIndicator';
exports.default = InstallationWaterLevelIndicator;
var templateObject_1;
//# sourceMappingURL=installation-water-level-indicator.component.js.map